// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-language-selector[data-v-c289029e] .modal{overflow:visible;padding-bottom:4rem;padding-top:4rem}.modal-language-selector[data-v-c289029e] .modal-header{padding-top:0!important}.modal-language-selector[data-v-c289029e] .btn-close{transform:translateY(-30px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
